import React, {memo} from 'react'
import {Header, Table} from 'semantic-ui-react'
import {getAmountString, toLocaleDateString} from '../../util'
import {withPropsPresent} from '../../hoc'
import SelectPlan from './select-plan'

const _SubscriptionSummary = (props) => {
  const {
    seats,
    nextInvoiceTimestamp,
    plan
  } = props
  return (
    <>
      <Header as='h3'>Summary</Header>
      <Table celled columns='16' data-testid='subscription-summary'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Total Users</Table.HeaderCell>
            <Table.HeaderCell>Next Invoice Date</Table.HeaderCell>
            <Table.HeaderCell>Next Invoice Balance</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell data-testid='subscription-summary-total-users'>{seats}</Table.Cell>
            <Table.Cell data-testid='subscription-summary-invoice-date'>{toLocaleDateString(new Date(nextInvoiceTimestamp * 1000))}</Table.Cell>
            <Table.Cell data-testid='subscription-summary-invoice-balance'>{getAmountString(seats * plan.amount)}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </>
  )
}

let SubscriptionSummary = (props) => {
  const {subscription} = props
  props = {
    ...props,
    seats: subscription.seats,
    nextInvoiceTimestamp: subscription.nextInvoiceTimestamp,
    plan: subscription.plan
  }
  return (<_SubscriptionSummary {...props}/>)
}


SubscriptionSummary = withPropsPresent(SubscriptionSummary, ['subscription'])
SubscriptionSummary = memo(SubscriptionSummary)
export {SubscriptionSummary, _SubscriptionSummary}

export default SubscriptionSummary